import React from 'react';
import './Profile.css';

// const PROFILE_API = 'https://myprofessionalprofile.azurewebsites.net/api/Resume';
const LOCAL_RESUME = process.env.PUBLIC_URL + '/resume.html';

const Profile = () => (
  <div className="profile-container" style={{ maxWidth: '900px', margin: '40px auto' }}>
    <h1>About Me</h1>
    <iframe
      // src={PROFILE_API}
      src={LOCAL_RESUME}
      title="Resume"
      width="100%"
      height="700px"
      style={{ border: 'none' }}
    />
    <p>
      {/* <a href={PROFILE_API} target="_blank" rel="noopener noreferrer"> */}
      <a href={LOCAL_RESUME} target="_blank" rel="noopener noreferrer">
        {/* Download my resume (PDF) */}
        Download my resume (HTML)
      </a>
    </p>
  </div>
);

export default Profile;